<template>
  <button
    v-show="hasV2Feature && !v2LayoutEnabled"
    data-testid="MM-toggleV2Button"
    :class="
      isChatWidgetOpen
        ? 'text-primary hover:text-primary-700'
        : 'hover:text-primary dark:hover:text-primary text-slate-500 dark:text-slate-300'
    "
    class="p-2 rounded-full opacity-80 bg-slate-100 dark:bg-slate-100/10 duration-200 shrink-0 h-max"
    @click="toggleChatWidget()"
  >
    <AiChatIcon class="h-5 w-5" />
  </button>
</template>

<script setup lang="ts">
import AiChatIcon from "@/components/icons/AiChatIcon.vue";

const { v2LayoutEnabled, toggleChatWidget, isChatWidgetOpen, hasV2Feature } =
  useV2Layout();
</script>

<style scoped></style>
